export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>
          Зонтик-трость с классической деревянной ручкой. Длина зонта составляет 89 см, а диаметр купола 122 см. Конструкция зонта состоит из прочного карбона, пластика и дерева, что обеспечивает долговечность в использовании. Спицы тоже покрыты деревянными наконечниками.<br>
          Запечатать зонт Вы можете любым цветом снаружи и любым изображением изнутри купола. А краски не потеряют свою яркость даже спустя сотни дождей!
        </p>
        <p>
          <b>Материалы:</b><br>
          дерево, пластик, полиэстер, карбон
        </p>
        <p>
          <b>Размеры:</b><br>
          Длина от кончика до ручки - 89 см<br>
          Длина спицы от середины купола - 60 см<br>
          Купол сшит из 8 треугольников, каждый размером со сторонами 60 см и основанием 40 см<br>
          Ручка, кончик, наконечники на спицах - деревянные.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
